export default "__VITE_ASSET__Ye_PaGhV__"